var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryAddressFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 12.75C20.75 13.2804 20.5393 13.7891 20.1642 14.1642C19.7891 14.5393 19.2804 14.75 18.75 14.75H2.75C2.21957 14.75 1.71086 14.5393 1.33579 14.1642C0.960714 13.7891 0.75 13.2804 0.75 12.75V5.25C0.75 2.75 2.75 0.75 5.25 0.75H16.75C18.95 0.75 20.75 2.55 20.75 4.75V12.75Z",
    transform: "translate(1.25 4.25)",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75H3.75V2.75",
    transform: "translate(14.25 8.25)",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75C3.25 0.75 5.25 2.75 5.25 5.25V12.75C5.25 13.2804 5.03929 13.7891 4.66421 14.1642C4.28914 14.5393 3.78043 14.75 3.25 14.75",
    transform: "translate(5.75 4.25)",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75H1.75",
    transform: "translate(5.25 10.5)",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryAddressFigma);
export default __webpack_public_path__ + "static/media/delivery-address-figma.caa4be1762ad57ef0126632361cebcf0.svg";
export { ForwardRef as ReactComponent };